import { render, staticRenderFns } from "./ActionButton.vue?vue&type=template&id=42c36342&scoped=true&"
import script from "./ActionButton.vue?vue&type=script&lang=js&"
export * from "./ActionButton.vue?vue&type=script&lang=js&"
import style0 from "./ActionButton.vue?vue&type=style&index=0&id=42c36342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c36342",
  null
  
)

export default component.exports